import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Shared layout for long-form legal pages (Terms, Privacy).
 * `sections` is an array of { heading, body } where body is a string or node.
 */
export default function LegalPage({ title, updated, intro, sections }) {
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 pt-16 pb-16">
      <p className="text-[11px] font-black uppercase tracking-[0.28em] text-emerald-400 mb-3">Legal</p>
      <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-white mb-2">{title}</h1>
      {updated && <p className="text-xs font-bold uppercase tracking-widest text-gray-600 mb-8">Last updated {updated}</p>}
      {intro && <p className="text-gray-400 text-base font-medium leading-relaxed mb-8">{intro}</p>}

      <div className="space-y-8">
        {sections.map((s) => (
          <section key={s.heading}>
            <h2 className="text-lg font-black uppercase tracking-tight text-white mb-2">{s.heading}</h2>
            <p className="text-sm text-gray-400 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </div>

      <p className="text-sm text-gray-500 mt-12">
        Questions? Visit{' '}
        <Link to="/support" className="text-emerald-400 font-bold hover:underline">Support</Link>{' '}
        or email{' '}
        <a href="mailto:support@lockedin-h2h.com" className="text-emerald-400 font-bold hover:underline">
          support@lockedin-h2h.com
        </a>.
      </p>
    </article>
  );
}
